// extracted by mini-css-extract-plugin
module.exports = {"deleteIcon":"cart-item_deleteIcon__iqapQ inline-block w-[20px] h-[20px] bg-cover bg-no-repeat mr-[16px] mt-[10px] cursor-pointer"};